import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { StrapiCustomerWriteData } from '../../api/strapiCrm';
import { strapiUpdateCustomer } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useUpdateCustomerMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { documentId: string; data: Partial<StrapiCustomerWriteData> }) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiUpdateCustomer(jwt, input.documentId, input.data);
    },
    onSuccess: async (_, variables) => {
      await qc.invalidateQueries({ queryKey: queryKeys.customersListPrefix(jwt) });
      await qc.invalidateQueries({
        queryKey: queryKeys.customerDetail(jwt, variables.documentId),
      });
    },
  });
}
